export const LEADS_MODAL_STEPS = {
    SETUP: 'setup',
    PREVIEW: 'preview',
    ENRICHING: 'enriching',
    REVIEW: 'review',
};

export const RESULT_BUCKETS = {
    NEW: 'new',
    DUPLICATES: 'duplicates',
};

/** Fixed page size enforced by the nearby_places API (max 20 per request). */
export const PREVIEW_PAGE_SIZE = 20;

/** Default Google Maps zoom for map-view nearby_places searches. */
export const DEFAULT_MAP_ZOOM = 13;

export const MAP_ZOOM_MIN = 0;
export const MAP_ZOOM_MAX = 21;

/** EntityListSelect + NewEntityList / DataGrid key for the leads preview table */
export const LEADS_PREVIEW_ENTITY = {
    entity: 'leadsPreview',
    trueName: 'leadsPreview',
};

/** Column `colId` used for row checkboxes (must match `LeadList` column def) */
export const LEADS_PREVIEW_CHECKBOX_COL_ID = 'lead';
